import { parse } from "valibot"
import clampNumber from "../../../../lib/ldsh/clampNumber"
import { CameraFarSchema, PERSPECTIVE_CAMERA_FAR_MAX, PERSPECTIVE_CAMERA_FAR_MIN } from "./CameraFar"
import { getDeviceUserPreference, setDeviceUserPreference } from "./deviceUserPreferencesSignal"

export function updateCameraFar(newValue : number): void {
  newValue = clampNumber(newValue,
    PERSPECTIVE_CAMERA_FAR_MIN,
    PERSPECTIVE_CAMERA_FAR_MAX)

  console.log('updateFar', getDeviceUserPreference().camera_far, '->', newValue)

  const parsedNewValue = parse(CameraFarSchema, newValue)

  setDeviceUserPreference({
    ...getDeviceUserPreference(),
    camera_far: parsedNewValue,
  })
}
